import { render, staticRenderFns } from "./TopbarLocation.vue?vue&type=template&id=129b38a5&scoped=true"
import script from "./TopbarLocation.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopbarLocation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TopbarLocation.vue?vue&type=style&index=0&id=129b38a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129b38a5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/components/ui/UiIcon.vue').default,UiSelectOption: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/components/ui/UiSelectOption.vue').default,UiSelect: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/components/ui/UiSelect.vue').default})
